/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Icon, Typography } from '@zapier/design-system';

type BackButtonProps = {
  /** Called when the button is clicked. */
  onClick: () => void;
};

const Styles = {
  button: css`
    ${Typography.Body4}
    font-weight: 600;
    color: ${Colors.Blue3};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-right: 10px;

    :hover,
    :focus {
      text-decoration: underline;
    }
  `,
};

/** Renders the back button used throughout the Get Help form. */
const BackButton = ({ onClick }: BackButtonProps) => (
  <button css={Styles.button} onClick={onClick} type="button">
    <Icon color="Blue3" name="arrowSmallLeft" size={24} />
    Back
  </button>
);

export default BackButton;
